const invalidDate = "Not reported";

function parseDate(value: string | null | undefined): Date | null {
  if (typeof value !== "string" || value.trim() === "") return null;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatDate(value: string | null | undefined): string {
  const parsed = parseDate(value);
  if (!parsed) return invalidDate;
  return new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric", year: "numeric" }).format(parsed);
}

export function formatDateTime(value: string | null | undefined): string {
  const parsed = parseDate(value);
  if (!parsed) return invalidDate;
  return new Intl.DateTimeFormat("en-US", { month: "numeric", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }).format(parsed);
}
